import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';

export class PaginatorI18n {

    constructor(private readonly translate: TranslateService) {}

    getPaginatorIntl(): MatPaginatorIntl {
        const paginatorIntl = new MatPaginatorIntl();
        this.translate.stream('ITEMS_PER_PAGE_LABEL').subscribe(val => {
          paginatorIntl.itemsPerPageLabel = val
          paginatorIntl.changes.next()
        });
        this.translate.stream('NEXT_PAGE_LABEL').subscribe(val => {
          paginatorIntl.nextPageLabel = val;
        });
        this.translate.stream('PREVIOUS_PAGE_LABEL').subscribe(val => {
          paginatorIntl.previousPageLabel = val;
        });
        this.translate.stream('FIRST_PAGE_LABEL').subscribe(val => {
          paginatorIntl.firstPageLabel = val;
        });
        this.translate.stream('LAST_PAGE_LABEL').subscribe(val => {
          paginatorIntl.lastPageLabel = val;
        });
        paginatorIntl.getRangeLabel = this.getRangeLabel.bind(this);

        return paginatorIntl;
    }

    private getRangeLabel(page: number, pageSize: number, length: number): string {
      let value = ""
        if (length === 0 || pageSize === 0) {
            this.translate.stream('RANGE_PAGE_LABEL_1', { length }).subscribe( val => {
              value = val;
            })

        }
        length = Math.max(length, 0);
        const startIndex = page * pageSize;
        // If the start index exceeds the list length, do not try and fix the end index to the end.
        const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
        this.translate.stream('RANGE_PAGE_LABEL_2', { startIndex: startIndex + 1, endIndex, length }).subscribe(val => {
          value = val;
        })
        return value;
    }
}
